import { createTheme } from "@kaggle/core";
import { ThemeProvider } from "styled-components";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { JupyterLabGlobalStyle } from "../../components/jupyter/JupyterLabGlobalStyle";

const darkTheme = createTheme({
  themeName: "dark",
  kernelSourceType: "notebook",
});

const STYLE_DIV_ID = "kaggle-jupyterlab-style";

export const renderStyle = () => {
  let styleRoot = document.getElementById(STYLE_DIV_ID);
  if (!styleRoot) {
    styleRoot = document.createElement("div");
    styleRoot.id = STYLE_DIV_ID;
    document.body.appendChild(styleRoot);
  }
  const reactRoot = createRoot(styleRoot);
  reactRoot.render(
    <ThemeProvider theme={darkTheme}>
      <JupyterLabGlobalStyle />
    </ThemeProvider>
  );
};
